import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const getOrderList = async (params: object) => {
  return await GET({ url: Api.getOrderList, params, showError: false })
}
export const getDetail = async (params: object) => {
  return await GET({ url: Api.getDetail, params, showError: false })
}
